import {
  useMutation,
  OperationVariables,
  MutationHookOptions,
} from "@apollo/client";
import { MutationFetchPolicy } from "@apollo/client/core/watchQueryOptions";
import { ApiLegacyName } from "../../constants/apollo";

export const useLegacyMutation = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: any,
  options?: MutationHookOptions<TData, TVariables>,
) => {
  const {
    fetchPolicy = "network-only",
    onError,
    ...restOptions
  } = options || {};

  const legacyOptions = {
    ...restOptions,
    onError: onError,
    fetchPolicy: fetchPolicy as MutationFetchPolicy,
    context: {
      api: ApiLegacyName.Legacy,
      ...(options?.context || {}),
    },
  };

  return useMutation<TData, TVariables>(query, legacyOptions);
};
